// src/data/SollData.js
// export const SollData = {
//     sollNiedrig: [
//         0.35, 0.408, 0.467, 0.525, 0.583, 0.642, 0.7, 0.758, 0.817, 0.875,
//         0.994, 1.114, 1.233, 1.352, 1.472, 1.591, 1.71, 1.83, 1.949, 2.068,
//         2.188, 2.307, 2.426, 2.546, 2.665, 2.784, 2.904, 3.023, 3.142, 3.262,
//         3.381, 3.5, 3.62, 3.739, 3.858, 3.978, 4.097, 4.217, 4.336, 4.455,
//         4.575, 4.694, 4.813, 4.933, 5.052, 5.171, 5.291, 5.41, 5.529, 5.649,
//         5.768, 5.887, 6.007, 6.126, 6.245, 6.365, 6.484, 6.603, 6.723, 6.842,
//         6.961, 7.081, 7.2, 7.481, 7.762, 8.043, 8.324, 8.605, 8.886, 9.167,
//         9.448, 9.729, 10.01, 10.29, 10.571, 10.852, 11.133, 11.414, 11.695, 11.976,
//         12.257, 12.538, 12.819, 13.1
//     ],
//     sollHoch: [
//         0.45, 0.525, 0.6, 0.675, 0.75, 0.825, 0.9, 0.975, 1.05, 1.125,
//         1.251, 1.377, 1.503, 1.629, 1.755, 1.881, 2.007, 2.133, 2.258, 2.384,
//         2.51, 2.636, 2.762, 2.888, 3.014, 3.14, 3.266, 3.392, 3.518, 3.644,
//         3.77, 3.896, 4.022, 4.148, 4.274, 4.4, 4.525, 4.651, 4.777, 4.903,
//         5.029, 5.155, 5.281, 5.407, 5.533, 5.659, 5.785, 5.911, 6.037, 6.163,
//         6.289, 6.415, 6.541, 6.667, 6.792, 6.918, 7.044, 7.17, 7.296, 7.422,
//         7.548, 7.674, 7.8, 8.114, 8.429, 8.743, 9.057, 9.371, 9.686, 10.0,
//         10.314, 10.629, 10.943, 11.257, 11.571, 11.886, 12.2, 12.514, 12.829, 13.143,
//         13.457, 13.771, 14.086, 14.4
//     ]
// };

// export const SollData = {
//     sollNiedrig: [
//         // Tag 1-10 original
//         0.35, 0.408, 0.467, 0.525, 0.583, 0.642, 0.70, 0.758, 0.817, 0.875,
//         // Tag 11-21 (Index 10-20) ~ von 0.875 bis 1.70
//         0.95, 1.03, 1.11, 1.18, 1.26, 1.33, 1.41, 1.48, 1.56, 1.63, 1.70,
//         // Tag 22-28 (Index 21-27) ~ von 1.70 bis 2.80
//         1.86, 2.02, 2.18, 2.34, 2.49, 2.65, 2.80,
//         // Tag 29-42 (Index 28-41) ~ von 2.80 bis 5.10
//         2.96, 3.12, 3.28, 3.45, 3.61, 3.78, 3.94, 4.11, 4.27, 4.44,
//         4.60, 4.77, 4.93, 5.10,
//         // Tag 43-56 (Index 42-55) ~ von 5.10 bis 8.20
//         5.32, 5.54, 5.76, 5.98, 6.20, 6.42, 6.64, 6.86, 7.08, 7.30,
//         7.52, 7.74, 7.96, 8.20,
//         // Tag 57-70 (Index 56-69) ~ von 8.20 bis 11.00
//         8.40, 8.60, 8.80, 9.00, 9.20, 9.40, 9.60, 9.80, 10.00, 10.20,
//         10.40, 10.60, 10.80, 11.00,
//         // Tag 71-84 (Index 70-83) ~ von 11.00 bis 13.10
//         11.15, 11.30, 11.45, 11.60, 11.75, 11.90, 12.05, 12.20,
//         12.35, 12.50, 12.65, 12.80, 12.95, 13.10
//     ],
//     sollHoch: [
//         // Tag 1-10 original
//         0.45, 0.525, 0.600, 0.675, 0.750, 0.825, 0.900, 0.975, 1.050, 1.125,
//         // Tag 11-21 (~1.125 → 2.50)
//         1.25, 1.38, 1.50, 1.63, 1.75, 1.88, 2.00, 2.13, 2.25, 2.38, 2.50,
//         // Tag 22-28 (~2.50 → 3.70)
//         2.67, 2.84, 3.01, 3.19, 3.36, 3.53, 3.70,
//         // Tag 29-42 (~3.70 → 6.30)
//         3.88, 4.06, 4.24, 4.43, 4.61, 4.79, 4.97, 5.15, 5.34, 5.52,
//         5.70, 5.88, 6.09, 6.30,
//         // Tag 43-56 (~6.30 → 9.90)
//         6.55, 6.80, 7.05, 7.30, 7.55, 7.80, 8.05, 8.30, 8.55, 8.80,
//         9.05, 9.30, 9.55, 9.90,
//         // Tag 57-70 (~9.90 → 12.70)
//         10.05, 10.20, 10.35, 10.50, 10.65, 10.80, 10.95, 11.10,
//         11.25, 11.40, 11.55, 11.70, 11.85, 12.00, 12.15, 12.30, 12.45, 12.60, 12.70,
//         // Tag 71-84 (~12.70 → 14.40)
//         12.85, 13.00, 13.15, 13.30, 13.45, 13.60, 13.75, 13.90,
//         14.05, 14.20, 14.30, 14.40
//     ]
// };

// export const SollData = {
//     sollNiedrig: [
//         // Tag 1-10 original
//         0.35, 0.408, 0.467, 0.525, 0.583, 0.642, 0.70, 0.758, 0.817, 0.875,
//         // Tag 11-21 (Index 10-20) ~ von 0.875 bis 1.70
//         0.95, 1.03, 1.11, 1.18, 1.26, 1.33, 1.41, 1.48, 1.56, 1.63, 1.70,
//         // Tag 22-28 (Index 21-27) ~ von 1.70 bis 2.80
//         1.86, 2.02, 2.18, 2.34, 2.49, 2.65, 2.80,
//         // Tag 29-42 (Index 28-41) ~ von 2.80 bis 5.10
//         2.96, 3.12, 3.28, 3.45, 3.61, 3.78, 3.94, 4.11, 4.27, 4.44,
//         4.60, 4.77, 4.93, 5.10,
//         // Tag 43-56 (Index 42-55) ~ von 5.10 bis 8.20
//         5.32, 5.54, 5.76, 5.98, 6.20, 6.42, 6.64, 6.86, 7.08, 7.30,
//         7.52, 7.74, 7.96, 8.20,
//         // Tag 57-70 (Index 56-69) ~ von 8.20 bis 11.00
//         8.40, 8.60, 8.80, 9.00, 9.20, 9.40, 9.60, 9.80, 10.00, 10.20,
//         10.40, 10.60, 10.80, 11.00,
//         // Tag 71-84 (Index 70-83) ~ von 11.00 bis 13.10
//         11.15, 11.30, 11.45, 11.60, 11.75, 11.90, 12.05, 12.20,
//         12.35, 12.50, 12.65, 12.80, 12.95, 13.10
//     ],
//     sollHoch: [
//         // Tag 1-10 original
//         0.45, 0.525, 0.600, 0.675, 0.750, 0.825, 0.900, 0.975, 1.050, 1.125,
//         // Tag 11-21 (~1.125 → 2.50)
//         1.25, 1.38, 1.50, 1.63, 1.75, 1.88, 2.00, 2.13, 2.25, 2.38, 2.50,
//         // Tag 22-28 (~2.50 → 3.70)
//         2.67, 2.84, 3.01, 3.19, 3.36, 3.53, 3.70,
//         // Tag 29-42 (~3.70 → 6.30)
//         3.88, 4.06, 4.24, 4.43, 4.61, 4.79, 4.97, 5.15, 5.34, 5.52,
//         5.70, 5.88, 6.09, 6.30,
//         // Tag 43-56 (~6.30 → 9.90)
//         6.55, 6.80, 7.05, 7.30, 7.55, 7.80, 8.05, 8.30, 8.55, 8.80,
//         9.05, 9.30, 9.55, 9.90,
//         // Tag 57-70 (~9.90 → 12.70)
//         10.05, 10.20, 10.35, 10.50, 10.65, 10.80, 10.95, 11.10,
//         11.25, 11.40, 11.55, 11.70, 11.85, 12.00, 12.15, 12.30, 12.45, 12.60, 12.70,
//         // Tag 71-84 (~12.70 → 14.40)
//         12.85, 13.00, 13.15, 13.30, 13.45, 13.60, 13.75, 13.90,
//         14.05, 14.20, 14.30, 14.40
//     ]
// };

export const SollData = {
    sollNiedrig: [0.35, 0.44609374999999996, 0.5421875, 0.63828125, 0.734375, 0.83046875, 0.9265625000000001, 1.02265625, 1.11875, 1.21484375, 1.3109375, 1.4070312500000002, 1.5031250000000003, 1.59921875, 1.6953125, 1.79140625, 1.8875000000000002, 1.9835937500000003, 2.0796875, 2.17578125, 2.271875, 2.36796875, 2.4640625000000003, 2.5601562500000004, 2.6562500000000004, 2.75234375, 2.8484375, 2.9445312500000003, 3.0406250000000004, 3.1367187500000004, 3.2328125, 3.32890625, 3.4250000000000003, 3.5210937500000004, 3.6171875000000004, 3.71328125, 3.809375, 3.9054687500000003, 4.0015625, 4.09765625, 4.19375, 4.28984375, 4.3859375, 4.4820312499999995, 4.578125, 4.67421875, 4.7703125, 4.86640625, 4.9625, 5.05859375, 5.1546875, 5.25078125, 5.346875, 5.44296875, 5.5390625, 5.63515625, 5.73125, 5.82734375, 5.9234375, 6.01953125, 6.115625, 6.21171875, 6.3078125, 6.40390625, 6.5, 6.83, 7.16, 7.49, 7.82, 8.15, 8.48, 8.809999999999999, 9.14, 9.469999999999999, 9.8, 10.129999999999999, 10.459999999999999, 10.79, 11.12, 11.45, 11.780000000000001, 12.11, 12.44, 12.77, 13.1],
    sollHoch: [0.45, 0.57578125, 0.7015625000000001, 0.82734375, 0.953125, 1.07890625, 1.2046875000000001, 1.33046875, 1.45625, 1.58203125, 1.7078125, 1.8335937500000001, 1.959375, 2.0851562500000003, 2.2109375000000004, 2.33671875, 2.4625000000000004, 2.5882812500000005, 2.7140625000000003, 2.8398437500000004, 2.965625, 3.0914062500000004, 3.2171875000000005, 3.3429687500000003, 3.4687500000000004, 3.5945312500000006, 3.7203125000000004, 3.8460937500000005, 3.9718750000000007, 4.09765625, 4.2234375, 4.34921875, 4.4750000000000005, 4.600781250000001, 4.726562500000001, 4.85234375, 4.978125, 5.1039062500000005, 5.229687500000001, 5.355468750000001, 5.48125, 5.60703125, 5.7328125000000005, 5.858593750000001, 5.984375000000001, 6.110156250000001, 6.2359375, 6.3617187500000005, 6.487500000000001, 6.613281250000001, 6.739062500000001, 6.86484375, 6.9906250000000005, 7.116406250000001, 7.242187500000001, 7.367968750000001, 7.493750000000001, 7.6195312500000005, 7.745312500000001, 7.871093750000001, 7.996875000000001, 8.12265625, 8.2484375, 8.37421875, 8.5, 8.795, 9.09, 9.385, 9.68, 9.975, 10.27, 10.565, 10.86, 11.155000000000001, 11.45, 11.745000000000001, 12.04, 12.335, 12.629999999999999, 12.925, 13.22, 13.515, 13.81, 14.105, 14.4]
};

